export default ({status, customer, payment}) => {
  return [
    {
      label: 'Гарчиг',
      name: 'title',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Харилцагч',
      name: 'customerid',
      type: 'select',
      className: 'col-span-12 mb-0',
      inputProps: {
        options : customer
      }
    },
    {
      label: 'Төлбөрийн төлөв',
      name: 'paymentid',
      className: 'col-span-12 mb-0',
      type: 'select',
      inputProps: {
        options: payment
      }
    },
    {
      label: 'Төлсөн дүн',
      name: 'payedamount',
      className: 'col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
    {
      label: 'Төлөв',
      name: 'status',
      type: 'select',
      className: 'col-span-12 mb-0',
      inputProps: {
        options: status ,
      }
    },
  ]
}